import tenants from './routes'

export {
  CreateTenant,
  PartnerSearch,
  PartnerSearchFormContext,
  TenantHierarchyTable,
  TenantSearch,
  TenantSearchBar,
  TenantSearchFormContext,
} from './components'
export { usePartnerSearchFormContext, useSearchPartners, useSearchTenantHierarchies, useSearchTenants } from './hooks'
export { TenantMenu } from './menus'
export { tenantReducer, tenantSlice } from './slice'
export type { Manager, Partner, PartnerSearchFormValues, Tenant, TenantSearchFormValues } from './types'

export default [...tenants] as const
